import { createRemoteComponentWrapper, RemoteComponentWrapperProps } from '@juliusbaer-gcrm/gcrm-frontend-components';

import { getEnv } from '../utils';
import { ContactNoteLoading } from './ContactNoteLoading';

export type ContactNoteWrapperProps = {
  /** @deprecated Use `linkedNoteUIDs` instead. Ignored when `linkedNoteUIDs` is non-empty. */
  linkedNoteIds?: string[];
  linkedNoteUIDs?: string[];
  allowUnlink?: boolean;
  brUId?: string[] | string;
  partnerUId?: string[] | string;
  size?: 'small' | 'medium' | 'large';
  callbackFunc?: (action: { type: string; payload: any[] }) => void;
} & RemoteComponentWrapperProps;

export const ContactNoteWrapperWC = createRemoteComponentWrapper<ContactNoteWrapperProps>({
  hostName: 'pcc-contact-note-host',
  remoteName: 'pcc-contact-notes-frontend-view',
  elementName: 'pcc-contact-notes-home-element',
  loadingComponent: <ContactNoteLoading />,
  getRemoteEntryUrl: getEnv,
});
